// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xniFk","label":"styles_label__359Hl"};